export default "__VITE_ASSET__D3x_GDaB__"